module.exports = __webpack_public_path__ + "static/media/notFound2.433d7b35.jpeg";